export default Object.freeze({
	COPY_TRANSACTION_ID: 'Copy Transaction ID',
	TRANSACTION_ID_COPIED: 'Transaction ID Copied',
	FAILED_PAYMENT_ATTEMPTS: 'Failed Payment Attempts',
	ATTEMPT_ID: 'Attempt ID',
	COPY_ATTEMPT_ID: 'Copy Attempt ID',
	ATTEMPT_ID_COPIED: 'Attempt ID Copied',
	SHOW_MORE: 'Show More',
	SHOW_LESS: 'Show Less',
	NEW_PAYLINK_NOTE:
		'Note: Newly created payment links may take some time to appear in the list.',
	SOMETHING_WENT_WRONG: 'Something went wrong',
	PRODUCTION_CREDENTIALS: 'Production Credentials',
	PRODUCTION_CREDENTIALS_INFO:
		'Use these production API key(s) to go live with PhonePe PG and start accepting payments',
	TEST_CREDENTIALS: 'Test Credentials',
	TEST_CREDENTIALS_INFO: 'Use these credentials for test integration',
	COMPLETE_ONBOARDING_MSG:
		'Please complete your onboarding to access Production Credentials',
	COMPLETE_NOW: 'Complete Now',
	DUMMY_API_KEY: '12345678-12345678-12345678-12345678',
	KEYS_IN_PROCESS_MSG:
		'Keys will be generated soon, you’ll be notified when it’s ready to use',
	ADMIN_TO_SHARE_KEY: 'Ask admin to share Key',
	ADMIN_TO_SHARE_KEY_INFO:
		'Only admins have access to API keys. Ask admin in your organisation to share the keys externally',
	SHOW_KEY: 'Show Key',
	DEVELOPER_SETTINGS: 'Developer Settings',
	PAYMENT_LINKS: 'Payment Links',
	COPY_KEY: 'Copy Key',
	KEY_COPIED: 'Key Copied',
	NO_PAYMENT_LINKS_FOUND: 'No Payment Links found',
	SEARCH_FOR_PAYMENT_LINKS: 'Search for paylinks',
	PAYMENT_LINK_GENERATION_IN_PROGRESS:
		'Payment link generation is in progress...',
	PAYMENT_LINK_GENERATION_ERRORED:
		'Failed to create payment link, please create again.',
	COPY_PAYLINK: 'Copy Paylink',
	PAYLINK_COPIED: 'Paylink Copied',
	SOMETHING_WENT_WRONG_PLEASE_RETRY: 'Something went wrong! Please try again.',
	PAYLINK_CANCELLED: 'Paylink Cancelled',
	NO_PAYMENT_LINKS_FOUND_FOR_FILTERS:
		'Your applied filters did not match any Payment Links. Please try again',
	NO_PAYMENT_LINKS_FOUND_FOR_SEARCH_VALUE: (searchValue: string) =>
		`Your seach "${searchValue}" did not match any Payment Links. Please try again.`,
	NO_PAYMENT_LINKS_FOUND_FOR_SEARCH_VALUE_AND_FILTERS: (searchValue: string) =>
		`Your seach "${searchValue}" combined with applied filters did not match any Payment Links. Please try again.`,
	PAYMENT_LINK_SENT_SUCCESSFULLY_TO: (target: string) =>
		`Paylink sent successfully to ${target}`,
	PAYMENT_LINK_CANCELLED_DESCRIPTION: (paylinkId: string) =>
		`Paylink ${paylinkId} cancelled. Customers will not be able to complete payment on this paylink now.`,
	PAYLINK_KYC_COMPLETE_TEXT: 'Please complete PG Onboarding first',
	PAYLINK_KYC_COMPLETE_SUBTEXT:
		'Once you complete your KYC and PG Onboarding, you will be able to activate, create, and receive payment through payment links.',
	COMPLETE_KYC: 'Complete Onboarding',
	ACTIVATE_TO_GET_STARTED: 'Activate to get started',
	ACTIVATE: 'Activate',
	ACTIVATE_PAYLINK_INFO:
		'Activate to start creating and receiving payments from Payment Links.',
	ACTIVATE_PAYLINK: 'Activate Payment Links',
	PAYLINK_ACTIVATED: 'Payment Links Activated!',
	PAYLINK_ACTIVATED_INFO:
		'You can now start using Payment Links. Create a link and share it with customers to receive payments.',
	CREATE_PAYMENT_LINK: 'Create Payment Link',
	ACTIVATING_PAYLINKS: 'Activating Paylinks...',
	ADMIN_COMPLETE_KYC: 'Please ask Admin to complete KYC first',
	ADMIN_COMPLETE_KYC_INFO:
		'Once the Admin completes KYC, they will be able to activate payment links!',
	ADMIN_ACTIVATE_PAYLINK: 'Please ask Admin to activate payment links',
	ADMIN_ACTIVATE_PAYLINK_INFO:
		'You can start using this feature once the Admin of this account activates payment links.',
	UNABLE_TO_ACTIVATE_PAYLINKS: 'Access to payment links not available',
	ACTIVATION_DISABLED_MSG: `We are unable to provide access to payment links for your account at the moment. Please contact PhonePe support at 'merchant-pgsupport@phonepe.com' for further details and action`,
	PAYLINK_NO_DATA:
		'Create a link and share it with your customers to receive payments easily',
	PAYLINK_NO_MERCHANT:
		'You must select a merchant store to access payment links',
	PAYLINK_SIMPLIFY:
		'Simplify payments for users by sharing payment links that use PhonePe’s secure standard checkout.',
	TRY_PAYMENT_LINKS_ITEMS: [
		'Create link in minutes: Just enter the payment amount & customer details and create a link. No coding or checkout page needed!',
		'Accept payments from anywhere: Copy and share links easily via SMS, email, or social media apps to accept payments.',
		'Complete control: Customise, create, share, and manage your payment links easily. Send reminders or cancel links anytime.',
		'Secure & fast checkout: Payment links use the trusted PhonePe standard checkout payment page – no need to set it up yourself.',
		'All payment options: Our payment links support all payment methods including UPI, credit cards, debit cards, and net-banking.',
		'Track in real-time: Stay informed with timely payment updates, daily sales monitoring, and detailed settlement reports.',
	],
	TRY_PAYMENT_LINKS: 'Try Payment Links!',
	COULD_NOT_ACTIVATE_PAYLINK: 'Could not activate payment links',
	COULD_NOT_ACTIVATE_PAYLINK_DESCRIPTION:
		'Due to some technical issue, we could not activate payment links for this account. Please try again after some time. If the issue persists after trying again, please contact us.',
	LOADING: 'Loading...',
	PHONEPE_REFERENCE_ID: 'PhonePe Reference Id',
	STORE_HOSTED_ON: 'Your Business is hosted on',
	WEBSITE: 'Website',
	WEBSITE_DESCRIPTION:
		'Websites built on platforms like Shopify, WooCommerce, OpenCart or other custom builds',
	ANDROID_APP: 'Android app',
	ANDROID_APP_DESCRIPTION: 'Native mobile application built for AndroidOS',
	IOS_APP: 'iOS app',
	IOS_APP_DESCRIPTION: 'Native mobile application built for iOS',
	WEBSITE_DETAILS: 'Website Details',
	ANDROID_APP_DETAILS: 'Android App Details',
	IOS_APP_DETAILS: 'iOS App Details',
	TYPE_OF_WEBSITE: 'Type of Website',
	WEBSITE_URL_LABEL: 'Website URL*',
	WEBSITE_URL_LABEL_REGISTER_PAGE:
		'Website/App URL on which you wish to accept Payments',
	STORE_URL_LABEL: 'Store URL*',
	APP_URL_LABEL: 'App URL*',
	APP_PACKAGE_NAME_LABEL: 'App package name*',
	APP_TYPE_LABEL: 'App Type*',
	EMPTY_DATA_TEXT_REPORT: 'There are 0 report generated in your account',
	SUCCESS_MESSAGE_REPORT_GENERATION:
		'Please wait, Report generation may take some time',
	INVALID_WEBSITE_TYPE: 'Please select your website type',
	INVALID_WEBSITE_URL: 'Please enter a valid Website URL',
	INVALID_STORE_URL: 'Please enter a valid Store URL',
	INVALID_APP_TYPE: 'Please select App Type',
	INVALID_APP_URL: 'Please enter a valid App URL',
	INVALID_APP_URL_HTTPS: 'App URL should start with https',
	INVALID_APP_PACKAGE_NAME: 'Please enter a valid App Package Name',
	ANDROID: 'Android',
	IOS: 'iOS',
	TNC: 'Terms and Conditions',
	POLICIES: 'Policies',
	TNC_URL: 'Terms and Conditions URL*',
	TNC_WEBSITE_URL: 'Terms and Conditions URL for Website*',
	TNC_ANDROID_URL: 'Terms and Conditions URL for Android app*',
	TNC_IOS_URL: 'Terms and Conditions URL for iOS app*',
	INVALID_TNC_URL: 'Please enter a valid T&C URL',

	REFUND_POLICY_URL: 'Refund policy URL*',
	SHIPPING_POLICY_URL: 'Shipping policy URL',
	RETURN_POLICY_URL: 'Return policy URL',
	PRIVACY_POLICY_URL: 'Privacy policy URL*',
	REFUND_POLICY_WEB_URL: 'Refund policy URL for Website*',
	SHIPPING_POLICY_WEB_URL: 'Shipping policy URL for Website',
	RETURN_POLICY_WEB_URL: 'Return policy URL for Website',
	PRIVACY_POLICY_WEB_URL: 'Privacy policy URL for Website*',
	REFUND_POLICY_ANDROID_URL: 'Refund policy URL for Android app*',
	RETURN_POLICY_ANDROID_URL: 'Return policy URL for Android app',
	SHIPPING_POLICY_ANDROID_URL: 'Shipping policy URL for Android app',
	PRIVACY_POLICY_ANDROID_URL: 'Privacy policy URL for Android app*',
	REFUND_POLICY_IOS_URL: 'Refund policy URL for iOS app*',
	SHIPPING_POLICY_IOS_URL: 'Shipping policy URL for iOS app',
	RETURN_POLICY_IOS_URL: 'Return policy URL for iOS app',
	PRIVACY_POLICY_IOS_URL: 'Privacy policy URL for iOS app*',
	INVALID_REFUND_POLICY_URL: 'Please enter a valid Refund policy URL',
	INVALID_RETURN_POLICY_URL: 'Please enter a valid Return policy URL',
	INVALID_SHIPPING_POLICY_URL: 'Please enter a valid Shipping policy URL',
	INVALID_PRIVACY_POLICY_URL: 'Please enter a valid Privacy policy URL',
	RETURN_NOT_SUPPORTED: 'My Business does not support returns',
	SHIPPING_NOT_SUPPORTED: 'My Business does not ship goods',
	NEXT: 'Next',
	PREVIOUS: 'Previous',
	SELECT_ONE_OPTION: 'Please select at least one option',
	OFFER_TEXT: `{PG_RATE} of all transactions`,
	PG_FEATURES: [
		'Accept payments with UPI, Cards and Net-Banking',
		'Manage payments with Dashboard',
		'Highly secure and easy Integration',
		'No hidden charges, set up fee, maintenance fee',
	],
	I_AGREE: 'I agree with the ',
	PLEASE_ACCEPT_TNC: 'Please accept Terms and Conditions',
	SUBMISSION_SUCCESS_HEADER: 'Thank you for submitting your details.',
	SUBMISSION_SUCCESS_DESCRIPTION: `We are verifying your KYC and website/app details.  Upon successful verification, you'll find the Production API keys in the 'Developer Settings' of your Dashboard, which you can use to take your operations live.`,
	WHAT_TO_DO: 'What you can do meanwhile',
	INTEGRATE_PG_HEADER: 'Integrate with PhonePe APIs Now for Payment Activation',
	INTEGRATE_PG_DESC1: `Please integrate your website or app with our PhonePe by visiting `,
	INTEGRATE_PG_DESC2: `. After successful verification, you'll be able to use the Production API keys to go live and start accepting payments. `,
	DEV_DOCS: 'developer.phonepe.com',
	CONTINUE: 'Continue',
	SKIP_EXPLORE_DASHBOARD: 'Skip and Explore Dashboard',
	WEB_APP_DETAILS: 'Website/App Details',
	WEB_APP_DESC:
		'Provide the details of the website or app where your business is hosted.',
	POLICIES_DESCRIPTION: `It is mandatory to provide the policies and terms & conditions to comply with Reserve Bank of India (RBI) guidelines.`,
	ACTIVATE_PG: 'Activate Payment Gateway',
	ACTIVATE_PG_DESC:
		'Fill the details of the Website/App on which you want to avail PhonePe Payment Gateway',
	ONBOARDING_HEADING: `Your Onboarding Journey`,
	ENTER_KYC_DETAILS: `Enter KYC details`,
	KYC_DETAILS: `KYC details`,
	KYC_DETAILS_SUBMITTED: `KYC details submitted`,
	COMPLETE_KYC_DESCRIPTION: `Enter information about your business, bank account, and GST to complete your KYC.`,
	KYC_SUBMITTED_DESCRIPTION: `We’ve received your KYC details and currently verifying it, which usually takes around 3-5 days.`,
	KYC_FAILED_DESCRIPTION:
		'Your KYC verification failed due to some discrepancies in information. Kindly check back and retry.',
	COMPLETE_KYC_BUTTON: 'Complete KYC',
	RE_SUBMIT_DETAILS: 'Resubmit Details',
	RESUME_KYC_BUTTON: 'Resume KYC',
	PENDING_ACTIVATION_DESCRIPTION:
		'We’ve received your Website/App details and currently verifying it, which usually takes around 3-5 days.',
	ERRORED_ACTIVATION_DESCRIPTION:
		'Activation failed due to some discrepancies in information. Kindly check back and retry.',
	PG_ACTIVATION: 'Activate Payment Gateway',
	PAYMENT_GATEWAY_DESCRIPTION:
		'Supercharge your business with our seamless payments experience.',
	PG_STATUS: {
		NOT_INITIATED: '',
		IN_PROGRESS: 'Verification in Progress',
		SUCCESS: '',
		FAILED: 'Verification failed',
	},
	VERIFICATION_SUCCESSFUL: 'Verification Successful',
	VERIFICATION_FAILED: 'Verification failed',
	COMPLETE_YOUR_KYC: 'Complete your KYC',
	BUSINESS_DETAILS: 'Business Details',
	BANK_DETAILS: 'Bank Details',
	GST_PAN_DETAILS: 'GST/PAN Details',
	UPLOAD_DOCUMENTS: 'Upload Documents',
	BUSINESS_NAME: 'Business Name*',
	BUSINESS_NAME_PLACEHOLDER: 'Enter Registered Business Name',
	INVALID_BUSINESS_NAME: 'Please enter a valid Business Name',
	DISPLAY_NAME: 'Display Name*',
	DISPLAY_NAME_PLACEHOLDER: 'Enter the name visible to your customers',
	INVALID_DISPLAY_NAME: 'Please enter a valid Display Name',
	LINE_OF_BUSINESS: 'Line of Business*',
	LINE_OF_BUSINESS_PLACEHOLDER: 'Select Line of your business',
	INVALID_LINE_OF_BUSINESS: 'Please select a valid Line of Business',
	CATEGORY_FETCH_ERROR: 'Unable to fetch category list.',
	BUSINESS_DESCRIPTION: 'Business Description',
	BUSINESS_DESC_PLACEHOLDER: 'What does your business do?',
	WEBSITE_URL: 'Website URL',
	KYC_SUBMITTED_HEADER:
		'Your KYC details have been submitted for verification!',
	KYC_SUBMITTED_SUB_HEADER:
		'We are currently in the process of verifying your information and will get back to you within 3-5 business days.',
	ACCEPTABLE_ACCOUNT: 'Details of Current Account only',
	ACCEPTABLE_ACCOUNT_DESC:
		'Please provide details of the Current Account associated with your business. Any other type of bank account will lead to KYC failure.',
	SAMPLE_TNC_DESC: `PhonePe doesn’t own the sample T&Cs and must be treated only as a reference. You can use it to customise T&Cs for your business.`,
	COPIED: 'Copied',
	VIEW_SAMPLE_TNC: 'View Sample Terms and Conditions',
	VIEW_SAMPLE_RETURN_POLICY: 'View Sample Return Policy',
	VIEW_SAMPLE_PRIVACY_POLICY: 'View Sample Privacy Policy',
	VIEW_SAMPLE_REFUND_POLICY: 'View Sample Refund Policy',
	VIEW_SAMPLE_SHIPPING_POLICY: 'View Sample Shipping Policy',
	SAMPLE_TNC_VIEW_DESC:
		'You can view a sample of Terms & Conditions by clicking on the button below. You can use this to customise your own T&Cs.',
	SAMPLE_SHIPPING_POLICY_DESC:
		'You can view a sample of Shipping Policy by clicking on the button below. You can use this to customise your own Shipping Policy.',
	SAMPLE_REFUND_POLICY_DESC:
		'You can view a sample of Refund Policy by clicking on the button below. You can use this to customise your own Refund Policy.',
	SAMPLE_RETURN_POLICY_DESC:
		'You can view a sample of Return Policy by clicking on the button below. You can use it to customise your own Return Policy.',
	SAMPLE_PRIVACY_POLICY_DESC:
		'You can view a sample of Privacy Policy by clicking on the button below. You can use this to customise your own Privacy Policy.',
	EMAIL_VERIFICATION_HEADER: 'Verify your Email Id',
	EMAIL_VERIFIED_HEADER: 'Email Verified',
	VERIFY_EMAIL: 'Verify Email',
	EMAIL_VERIFICATION_DESCRIPTION: `Your email, {email} is pending to be verified. Verify email to receive all relevant updates.`,
	EMAIL_VERIFIED: 'Your email has been successfully verified.',
	EMAIL_VERIFY_PENDING: 'Email Verification Pending',
	VERIFICATION_EMAIL_SENT: 'Verification email sent',
	GET_STARTED_WITH_EMAIL:
		'In the meantime, get started with verifying your email',
	STARTING_EMAIL_VERIFICATION: 'Redirecting to email verification in ',
	INTEGRATE_STORE_WITH_PG: 'Integrate your website or app with PhonePe',
	DEV_DOC_DESCRIPTION_1: 'Please visit ',
	DEVELOPER_DOC_LINK: 'developer.phonepe.com',
	DEV_DOC_DESCRIPTION_2:
		' to integrate your Website/App with PhonePe. Once your KYC and Website/App details are verified, use the production API keys to go live and start accepting payments.',
	SEE_HOW: 'See how',
	SUBSCRIPTION_SETUP: 'Subscription Setup',
	SUBSCRIPTION_REDEMPTION: 'Subscription Redemption',
	KYC_IN_PROGRESS: 'Verification in Progress',
	CONTENT_COPIED: 'Content copied',
	TERMS_AND_CONDITIONS: 'Terms & Conditions',
	T_AND_C: 'T&C',
	DONT_HAVE_TNC: `Don’t have Terms and Conditions?`,
	SHIPPING_POLICY: 'Shipping Policy',
	DONT_HAVE_SHIPPING_POLICY: `Don’t have Shipping policy?`,
	REFUND_POLICY: 'Refund Policy',
	DONT_HAVE_REFUND_POLICY: `Don’t have Refund policy?`,
	RETURN_POLICY: 'Return Policy',
	DONT_HAVE_RETURN_POLICY: 'Don’t have Return policy?',
	PRIVACY_POLICY: 'Privacy Policy',
	DONT_HAVE_PRIVACY_POLICY: 'Don’t have Privacy policy?',
	WELCOME_TEXT: 'Welcome!',
	WELCOME_PG_TEXT:
		'Complete your onboarding to start accepting payments on PhonePe Payment Gateway!',
	HTTPS_TEXT: 'https://',
	// Register page
	LOGIN: 'Login',
	ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',
	SIGNUP_EMAIL_DESCRIPTION: `You will receive a verification link on this Email ID`,
	SIGNUP_MOBILE_DESCRIPTION: `You will receive OTP on this mobile number`,
	RE_ENTER_VALID_EMAIL: `Please enter a valid Email ID`,
	RE_ENTER_VALID_MOBILE: `Please enter a valid mobile number`,
	PROCEED: 'PROCEED',
	VERIFY: 'Verify',
	MOBILE_INPUT_LABEL: 'Phone Number',
	EMAIL_INPUT_LABEL: 'Email ID',
	MOBILE_INPUT_PLACEHOLDER: 'XXXXXXXXXX',
	EMAIL_INPUT_PLACEHOLDER: 'Enter Email ID',
	OTP_INPUT_LABEL: 'OTP',
	OTP_INPUT_PLACEHOLDER: 'Enter OTP',
	OTP_INPUT_DESCRIPTION: 'Enter your OTP here',
	ONLINE_LEAD_FILTER_LABEL: 'Website/App/Social Media',
	OFFLINE_LEAD_FILTER_LABEL: 'In Store/Shop',
	PAYMENT_GATEWAY: 'Payment Gateway',
	LEAD_FILTER_HEADER: 'Where do you want to accept payments?',
	BUSINESS_NEED_HEADER: 'Which product best fits your business needs?',
	TNC_AGREE_FOOTER: 'By signing up you agree to our',
	UNABLE_TO_REGISTER: 'Unable to register? ',
	COUNTRY_CODE_INDIA: '+91',
	SETTLEMENT_PAGE_HEADING:
		'View the consolidated payouts of the transactions to your Bank Account',
	GET_STARTED: 'Get Started',
	ONBOARDING_GET_STARTED_DESC:
		'Grow your business with our secure and seamless payment solutions.',
	KYC_VERIFICATION_FAILED: 'KYC Verification Failed',
	KYC_VERIFICATION_FAILURE_DESC:
		'The verification was unsuccessful due to some inaccuracies in the information provided.',
	COMPLETE_INTEGRATION: 'Complete Integration',
	INTEGRATION_DESC1: `We’re verifying the details submitted. It usually takes around 3-5 days.`,
	INTEGRATION_DESC2: `Meanwhile, you can integrate your website with PhonePe PG APIs so that you can start accepting payments as soon as verification is done`,
	ACTIVATE_PG_SHORT: 'Activate PG',
	PG_ACTIVATION_FAILED: 'Payment Gateway Activation Failed',
	PG_ACTIVATION_FAILURE_DESC:
		'The verification was unsuccessful due to some inaccuracies in the information provided.',
	SUPERCHARGE_YOUR_PAYMENT: 'Supercharge your Payment',
	EXPERIENCE_WITH: 'Experience with',
	PHONEPE_PAYMENT_GATEWAY: 'PhonePe Payment Gateway!',
	FREE: 'Free*',
	OTP_SENT_SUCCESSFULLY: 'OTP sent successfully.',
	SIGNUP_HEADER_TEXT: 'Register your business with PhonePe Payment Gateway',
	ENTER_REGISTERED_WEBSITE: 'Enter Registered Business website',
	YOUR_BUSINESS_NAME: 'Your Business Name',
	BUSINESS_ADDRESS: 'Business Address',
	INVALID_BUSINESS_ADDRESS: 'Invalid Business Address',
	FIELD_CANNOT_BE_EMPTY: 'This field cannot be empty',
	ENTER_COMPLETE_BUSINESS_ADDRESS: 'Enter complete address of your business',
	REFUND_REQUEST_TIME: 'Refund Request Time',
	REFUND_PROCESSING_TIME: 'Refund Processing Time',
	SHIPPING_TIME: 'Shipping Time',
	RETURN_REQUEST_TIME: 'Return Request Time',
	IN_DAYS: 'In Days',
	POLICY_PREVIEW_HEADER:
		'This document includes your business details and context of details we can pre-fill which you can edit and use for reference.',
	REVIEW_AND_DOWNLOAD_DOCUMENTS: 'Review and Download Documents',
	CUSTOM_DOCUMENTS_CAN_BE_PREVIEWED:
		'The following custom documents have your business details and can be previewed:',
	PROVIDED_LIST_OF_DOCUMENTS:
		'List of documents we will provide for your business:',
	PREVIEW: 'Preview',
	FILL_THE_BUSINESS_DETAILS_FOR_CUSTOM_DOCUMENTS:
		'Your selected custom documents would include your business details and context of details we can pre-fill which you can edit accordingly and proceed to preview.',
	DETAILS: 'Details',
	CONSENT_GENERATE_TNC:
		'I understand that the content provided is not a legal advice, and I agree to this',
	PREVIEW_AND_DOWNLOAD: 'Preview and download',
	EDIT: 'Edit',
	CHOOSE_THE_DOCUMENT_YOU_NEED: 'Choose the policies you need:',
	CHOOSE_CUSTOM_POLICY_DOCUMENTS:
		'PhonePe will provide custom policies which would include your business details and choose the ones you need to proceed:',
	LIST_OF_DOCUMENTS: 'List of documents',
	DOWNLOAD: 'Download',
	DISCLAIMER: 'disclaimer',
	BACK: 'Back',
	DONOT_HAVE_ANY_POLICIES: 'Don’t have Policies? We’ll create them for you.',
	HELP_GENERATING_POLICIES:
		'You can download the policies you need in a few simple steps. Once that’s done, add those policies to your website or app and provide the link below.',
	GENERATE_POLICIES: 'Generate Policies',
	INVALID_NUMBER_OF_DAYS: 'Invalid number of days',
	CLICK_HERE: 'Click here',
	NEED_HELP_LOGIN_TEXT: 'For business account of your shop/store, Watch ',
	NEED_HELP_PG_TEXT: 'Unable to login to Payment Gateway? ',
	WATCH_VIDEO_TEXT: 'Video',
	API_KEYS: 'API Keys',
	WEBHOOKS: 'Webhooks',
	CANCEL: 'Cancel',
	DELETE: 'Delete',
	WEBHOOK_DETAILS: 'Webhook Details',
	WEBHOOK_URL: 'Webhook URL',
	STATUS: 'Status',
	DESCRIPTION: 'Description',
	ACTIVE_EVENTS: 'Active Events',
	LAST_UPDATED_AT: 'Last Updated At',
	CREATED_AT: 'Created At',
	WEBHOOK_DELETE_CONFIRMATION: 'Are you sure you want to delete the webhook?',
	CREATE_NEW_WEBHOOK: 'Create New Webhook',
	WEBHOOKS_LOADING_FAILURE: 'Unable to get Webhooks list',
	WEBHOOK_DELETE_SUCCESS: 'Webhook deleted successfully',
	WEBHOOK_DELETE_FAILURE: 'Unable to delete webhook, Try again',
	WEBHOOK_SUBMIT_FAILURE: 'Unable to submit webhook details!!',
	WEBHOOK_CREATE_SUCCESS: 'Webhook created successfully',
	WEBHOOK_UPDATE_FAILURE: 'Something went wrong, Please try again!',
	WEBHOOK_EDIT_SUCCESS: 'Webhook saved successfully',
	WELCOME_PB: 'Welcome to PhonePe Business',
	ONBOARDING_SUCCESS: 'You have successfully completed your onboarding',
	BUSINESS_NOT_LIVE:
		'Your business is not LIVE yet. Please do the following next steps to go LIVE.',
	PENDING: 'Pending',
	CREATE_FIRST_WEBHOOK:
		'Create your first webhook to get you Payment status and let your customer know the payment status.',
	INTEGRATE_BUSINESS_DEV_DOCS:
		'Integrate your business with PhonePe APIs by visiting <a href="https://developer.phonepe.com" target="_blank">developer.phonepe.com</a>. You can access your API keys from the developer settings',
	VALID_WEBHOOK_URL: 'Please enter a valid Webhook Url',
	VALID_USERNAME: 'Please enter a valid Username',
	MIN_LENGTH_VALID_USERNAME: 'Username must be atleast 5 characters',
	MAX_LENGTH_VALID_USERNAME: 'Username must be upto 20 characters only',
	ALPHA_NUMERIC_USERNAME: 'Username should not contain special characters',
	VALID_PASSWORD: 'Please enter a valid Password',
	VALID_ALPHANUMERIC_PASSWORD:
		'Password should contain both alpha and numeric characters',
	MIN_LENGTH_VALID_PASSWORD: 'Password must be atleast 8 characters',
	MAX_LENGTH_VALID_PASSWORD: 'Password must be upto 20 characters only',
	MIN_COUNT_EVENT: 'Please choose atleast one active event',
	SETUP_DETAILS: 'Please fill the below setup details',
	BENEFITS: 'Benefits',
	ADDITIONAL_TERMS: '“Additional Terms”',
	FEEDBACK_SHARED_MSG: 'Thanks for sharing your feedback.',
	ALL_REFUNDS: 'All Refunds',
	BULK_REFUNDS: 'Bulk Refunds',
	VERIFYING_WEBSITE: 'Verifying your website...',
	VERIFYING_WEBSITE_SUBTITLE: 'This may take around 30 seconds',
	TILL_SECOND_MONTH_STARTING:
		'0% (Free) will be there till the end of second month starting from the month of production keys credentials.',
	BLENDED_RATE_WILL_BE_CHARGED:
		'blended will be charged post that except the below mentioned cards. Terms and Conditions Apply:',
	// New Pg register landing related constants
	GET_STARTED_FOR_FREE: 'GET STARTED FOR FREE',
	WHY_PHONEPE_PG: 'Why PhonePe PG?',
	TRUSTED_BY_INDIA_LARGEST: 'Trusted by India’s largest online brands',
	TRUSTED_BY: 'TRUSTED BY',
	SUPPORTS_EXTENSIVE_PLATFORMS: 'Supports Extensive Platforms',
	E_COMMERCE_PLUGINS: 'E-Commerce Plugins',
	FREQUENTLY_ASKED_QUESTIONS: 'Frequently Asked Questions',
	MORE_QUESTIONS: 'More questions',
	ALL_RIGHTS_RESERVED: '2024, All rights reserved',
	SIGN_UP_FOR_PHONEPE_PG:
		'Sign up for PhonePe Payment Gateway now and start accepting payments instantly',
	EASY_ONBOARDING: 'Easy Onboarding',
	DEVELOPER_FRIENDLY_APIS: 'Developer friendly APIs',
	ROBUST_SUPPORT: 'Robust Support',
	LIMITED_PERIOD_OFFER: 'Limited Period Offer',
	STANDARD_PLAN: 'Standard Plan',
	TNC_APPLY: 'T&C Apply',
	SIMPLE_TRANSPARENT: 'Simple, Transparent',
	PRICING: 'Pricing',
	HERES_WHY: 'Here’s why',
	PHONEPE_PG: 'PhonePe Payment Gateway',
	LEADING_BUSINESS: 'leading businesses',
	PREFER: 'prefer',
	INDIAS: 'India’s',
	EXCLUSIVE: 'Exclusive',
	QUICK_CHECKOUT: 'Quick Checkout',
	ENABLE_CUSTOMERS_TO_COMPLETE:
		'Enable customers to complete transactions without exiting your website or application',
	ENABLE_CUSTOMERS_TO_COMPLETE_FULL_DESC:
		'Enable customers to complete transactions without exiting your website or application with our unique half-pay-page experience within your checkout.',
	COLLECT_PAYMENTS_EASILY: 'Collect payments easily through links',
	COLLECT_PAYMENTS_EASILY_FULL_DESC:
		'Collect payments easily through links that you can generate & share with your customers. Payment links allow you to conduct business, even without a website or an app.',
	PAY_ON_DELIVERY: 'Pay on Delivery',
	FACILIATE_DIGITAL_PAYMENTS: 'Facilitate digital payments for COD orders',
	FACILIATE_DIGITAL_PAYMENTS_FULL_DESC:
		'Facilitate digital Payments for COD orders at your customer’s doorstep with our contactless payment solution that helps you reduce cash handling costs.',
	DYNAMIC_QR: 'Dynamic QR',
	ALLOW_YOUR_CUSTOMERS_TO_SCAN:
		'Allow your customers to scan & pay using any UPI app',
	ALLOW_YOUR_CUSTOMERS_TO_SCAN_FULL_DESC:
		'Allow your customers to scan & pay using UPI app with dynamic QR codes, generating better conversions and preventing VPA data entry errors.',
	SUBSCRIPTION_ENABLED: 'Subscription Enabled',
	AUTOPAY: 'AutoPay',
	A_SEAMLESS_SUBSCRIPTION_SOL: 'A seamless subscription solution',
	A_SEAMLESS_SUBSCRIPTION_SOL_FULL_DESC:
		'A seamless subscription solution that also lets you display varying amounts for each cycle, ensuring revenue lock-in & customer retention.',
	FAST_FORWARD: 'Fast Forward',
	REDUCE_MULTIPLE_STEPS:
		'Reduce multiple steps in your customer’s payment journey',
	REDUCE_MULTIPLE_STEPS_FULL_DESC:
		'	Reduce multiple steps in your customer’s payment journey with a one-click checkout, resulting in faster payments and better success rates.',
	ZERO_HIDDEN_CHARGES: 'Zero hidden charges',
	ZERO_SETUP_FEE: 'Zero setup fee',
	ZERO_ANNUAL_FEE: 'Zero annual maintenance fee',
	UNLOCK_3_MONTHS_OF: 'Unlock 3 Months* of Seamless Payments',
	EXPERIENCE_THE_POWER_OF: 'Experience the Power of PhonePe Payment Gateway',
	REGISTER_FOR_PHONEPE: 'Register for PhonePe',
	PAYMENT_GATEWAY_AT_ZERO_COST: 'Payment Gateway at Zero Cost',
	TNC_LIMITED_OFFER: '* T & C Apply. Limited Period Offer',
	REFERRED_MOBILE_HELPER_TEXT:
		'Please use the same mobile number as given by your referral partner during referral creation',
	LOGIN_TO_ACCOUNT: 'Login to your account',
	LOGIN_REDIRECTION: {
		VERIFICATION_SUCCESS: 'Store Successfully Linked',
		VERIFICATION_SUCCESS_DESC:
			'Your PhonePe Payment Gateway MID is successfully linked to your Shopify store. You can now start accepting payments seamlessly.',
		ONBOARDING_URL_MISMATCH: 'Incorrect Shopify URL',
		ONBOARDING_URL_MISMATCH_DESC: `Looks like the URL you provided during onboarding with PhonePe Payment Gateway does not match the URL linked to Shopify. Please try again with the correct URL.`,
		INVALID_MERCHANT_TYPE: `You're not registered as a Shopify merchant`,
		INVALID_MERCHANT_TYPE_DESC:
			'Please onboard as a Shopify merchant on PhonePe Payment Gateway to proceed.',
		ONBOARDING_INCOMPLETE: 'PhonePe PG Onboarding Incomplete',
		ONBOARDING_INCOMPLETE_DESC: `Looks like you haven't completed your onboarding with PhonePe Payment Gateway yet. Please complete your onboarding first to proceed with linking your account here.`,
		TECHNICAL_ISSUE: 'Technical Issue',
		GENERIC_ERROR:
			'Could not verify your account. Please log out and try logging in again.',
		REDIRECTING_BACK_TO: 'Redirecting back to {APP} in {TIME}s...',
		LOGIN_AS_ADMIN: 'Note: Ensure you log in with the Admin account.',
		ISSUE_PERSISTS: 'If the issue persists, ',
	},
	LOGOUT: 'LOG OUT',
	CONTACT_SUPPORT: 'Contact Support',
	RESET_PASSWORD_SUCCESS: 'A link to reset your password has been sent to',
	ADDRESS_UPDATE_SUCCESS: 'Address updated successfully.',
	NAME_UPDATE_SUCCESS: 'Name updated successfully.',
	COMPLETE_YOUR_ONBOARDING: `Complete your onboarding journey to start seeing {SCREEN_TYPE} here.`,
	PLEASE_ASK_ADMIN_TO_COMPLETE: `Please ask admin to complete the onboarding journey to start seeing {SCREEN_TYPE} here.`,
	PROCEED_TO_ONBOARDING: 'Proceed To Onboarding',
	PROCEED_TO_INTEGRATION: 'Proceed To Integration',
	EMAIL_UPDATE_NOTES: [
		'Email id will be updated via this process',
		'Reports will be shared to the new email post verification',
		'Registered mobile number OTP verification is required to go ahead with the change request',
	],
	EMAIL_REQUIRED_MESSAGE: 'Please enter an email.',
	EMAIL_VALIDATION_MESSAGE: 'Please enter a valid email.',
	EMAIL_MODAL_TITLE: 'Update Email',
	OTP_MODAL_TITLE: 'Verify OTP',
	OTP_REQUIRED_MESSAGE: 'Please enter OTP',
	OTP_VALIDATION_MESSAGE: 'Please enter a valid OTP.',
	OTP_SUCCESS_MESSAGE: `Verification email sent to {email}. Please click 'Verify Now' to continue.`,
	OTP_INVALID_MESSAGE: 'OTP is incorrect. Please enter the correct OTP.',
	ERROR_IN_LOADING_TICKETS: 'Error in getting tickets.',
});
